// @ts-nocheck
import React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getWishListLinesDataView } from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import setEditingSortOrder from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetEditingSortOrder";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import SelectInline, { SelectInlineStyles } from "@store/Library/Components/Toolkit/SelectInline";

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    wishListDataView: getWishListState(state, state.pages.myListDetails.wishListId),
    wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
    loadWishListLinesParameter: state.pages.myListDetails.loadWishListLinesParameter,
});

const mapDispatchToProps = {
    updateLoadWishListLinesParameter,
    loadWishListLines,
    setEditingSortOrder,
};

/** Minimal styles needed for the header & sort */
interface MinimalStyles {
    wrapper?: { css?: ReturnType<typeof css> };
    sortByWrapper?: { css?: ReturnType<typeof css> };
    sortBySelectInline?: SelectInlineStyles;
}

const styles: MinimalStyles = {
    wrapper: {
        css: css``,
    },
    sortByWrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
};

const MyListsDetailsListHeader = ({
    wishListDataView,
    wishListLinesDataView,
    loadWishListLinesParameter,
    setEditingSortOrder,
    updateLoadWishListLinesParameter,
    loadWishListLines,
}: Props) => {
    if (!wishListDataView.value) {
        return null;
    }

    const wishList = wishListDataView.value;

    const sortByChangeHandler = (sortBy: string) => {
        setEditingSortOrder({ editingSortOrder: false });
        updateLoadWishListLinesParameter({ sort: sortBy });
        loadWishListLines();
    };

    const canShowSortBy =
        !!wishListLinesDataView.value &&
        !!wishListLinesDataView.pagination?.sortOptions &&
        wishListLinesDataView.pagination.sortOptions.length > 0 &&
        (!wishList.isSharedList || wishList.allowEdit) &&
        !wishList.isAutogenerated &&
        !wishList.isDynamic;

    return (
        <StyledWrapper {...styles.wrapper}>
            <CardListHeading heading="" hasNoResults>
                {canShowSortBy ? (
                    <StyledWrapper {...styles.sortByWrapper} data-test-selector="myListDetailPage_ProductsSortBy">
                        <SelectInline
                            label={translate("{0}:", translate("Sort by"))}
                            labelPosition="left"
                            uid="myLists_sort"
                            value={loadWishListLinesParameter.sort}
                            extendedStyles={styles.sortBySelectInline}
                            onChange={event => sortByChangeHandler(event.currentTarget.value)}
                        >
                            {wishListLinesDataView.pagination?.sortOptions?.map(sortOption => (
                                <option value={sortOption.sortType} key={sortOption.sortType}>
                                    {sortOption.displayName}
                                </option>
                            ))}
                        </SelectInline>
                    </StyledWrapper>
                ) : null}
            </CardListHeading>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyListsDetailsListHeader),
    definition: {
        group: "My Lists Details",
        displayName: "List Details Headers",
        allowedContexts: ["MyListsDetailsPage"],
    },
};

export default widgetModule;
